<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  /* Hizmetlerimiz sayfası dönen resim js kodu */
document.addEventListener('DOMContentLoaded', function() {
  var img = document.querySelector('.anim-rotate');
  if (img) {
    function rotate() {
      img.style.transform = 'rotate(' + (parseFloat(img.dataset.angle || 0) + 1) + 'deg)';
      img.dataset.angle = (parseFloat(img.dataset.angle || 0) + 1) % 360;
      requestAnimationFrame(rotate);
    }
    requestAnimationFrame(rotate);
  }
});

  /* Hizmetlerimiz sayfası dönen resim js kodu */